<template>
  <div class="cardmodel-form">
    <v-row>
      <v-col cols="8">
        <v-alert type="warning">
          Afin de garantir un fonctionnement correct des statistiques,<br />
          il est important de veuiller à ce que tous les modèles de cartes
          forment un couple unique pour les éléments suivants :<br />
          - L'origine de la carte - Le type de la carte (billing, décompte,
          temps, séminaire) - Le nombre de sessions simultanées autorisées
          (sessions) - La durée maximale de connexion (durée) - La durée
          maximale d'utilisation (validité)
        </v-alert>
        <v-text-field
          v-model="parentCardModelForm.description"
          label="Description "
          hint="Courte description"
          persistent-hint
          :rules="rules.descriptionRules"
        >
        </v-text-field>
        <v-text-field
          v-model="parentCardModelForm.labelFrench"
          label="Libellé Français "
          hint="Pour les portails V4 le libellé français est utilisé en tant que clef de traduction.

"
          persistent-hint
          :rules="rules.label_frenchRules"
        >
        </v-text-field>
        <v-text-field
          v-model="parentCardModelForm.labelEnglish"
          label="Libellé Anglais"
          hint="Les libellés Anglais sont affichés dans les portails V2/V3 si le la langue sélectionnée n'est pas FR
"
          persistent-hint
          :rules="rules.label_englishRules"
        >
        </v-text-field>

        <v-select
          v-model="parentCardModelForm.cardOrigin"
          label="Origine"
          hint="Origine de la carte"
          persistent-hint
          :items="cardOriginsChoice"
          item-value="value"
          item-text="text"
        >
        </v-select>

        <v-select
          item-value="value"
          item-text="text"
          v-model="parentCardModelForm.cardType"
          label="Type"
          hint="Type de cartes:
- DECOMPTE: Le temps est consommé sans logout,
- TEMPS: Durée de connexion fixée,
- SEMINAR: Spécifique pour certaines chambres/salles pendant une période de temps fixée.
- BILLING: La carte sera facturée plus tard"
          persistent-hint
          :items="cardTypesChoice"
        >
        </v-select>
        <v-text-field
          v-model.number="parentCardModelForm.simultaneousSessionsNum"
          label="Nombre de sessions simultanées autorisées (optional)"
          hint="Il s'agit du nombre de sessions simultanées authorisées pour une carte. Cela peut être vu comme le nombre de périphérique (PC, Smartphone, tablettes) authorisé à ce se connecter en même temps avec la même carte.
laisser vide ce champs siginifie : pas de limite"
          persistent-hint
          :rules="rules.simultaneous_sessions_numRules"
          type="number"
        >
        </v-text-field>

        <v-text-field
          v-model.number="parentCardModelForm.maxConnectionDuration"
          label="Durée max de connexion (optional)"
          hint="Une carte DECOMPTE à une 'durée maximale de connexion' (son temps d'utilisation).
        Une carte TEMPS doit avoir une 'durée maximale de connexion' VIDE !
        "
          type="number"
          persistent-hint
          :rules="rules.max_connection_durationRules"
        >
        </v-text-field>

        <v-text-field
          v-model.number="parentCardModelForm.maxUsageDuration"
          label="Durée maximale d'utilisation (optional)"
          hint="Si une carte DECOMPTE à une 'durée maximale d'utilisation', la carte sera valable le temps de cette valeure à partir de la première utilisation sinon le champs doit être VIDE !
        Une carte TEMPS à une 'durée maximale d'utilisation' Cette durée définie la date de fin de la carte à partir de la 1ère utilisation.
        "
          type="number"
          persistent-hint
          :rules="rules.max_usage_durationRules"
        >
        </v-text-field>

        <v-text-field
          v-model.number="parentCardModelForm.idleTimeout"
          label="IDLE Timeout"
          hint="IDLE Timeout"
          :rules="rules.idle_timeoutRules"
          persistent-hint
          type="number"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-alert type="error"> Les durées sont exprimées en secondes </v-alert>
        <v-alert type="warning">
          To ensure a correct statistics behaviour, you have to take care of
          providing a unique set of informations for the following elements: The
          card origin. The card type (billing, countdown, time, seminar). The
          number of simultaneous sessions authorized for the card. The maximal
          connexion duration. The maximal usage duration.
        </v-alert>

        <table
          style="text-align: left; width: 330px; height: 128px"
          border="0"
          cellpadding="2"
          cellspacing="2"
        >
          <tbody>
            <tr>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(204, 204, 204);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                600
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(204, 204, 204);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                10 Minutes
              </td>

              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                86400
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                1 jour
              </td>
            </tr>
            <tr>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(204, 204, 204);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                900
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(204, 204, 204);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                15 Minutes
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                259200
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                3 jours
              </td>
            </tr>
            <tr>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(204, 204, 204);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                1800
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(204, 204, 204);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                30 Minutes
              </td>

              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                345600
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                4 jours
              </td>
            </tr>
            <tr>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                3600
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                1 heure
              </td>

              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                432000
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                5 jours
              </td>
              <td
                style="
                  vertical-align: top;
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                <br />
              </td>
              <td
                style="
                  vertical-align: top;
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                <br />
              </td>
            </tr>
            <tr>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                7200
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                2 heures
              </td>

              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                604800
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                7 jours
              </td>
              <td
                style="
                  vertical-align: top;
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                <br />
              </td>
              <td
                style="
                  vertical-align: top;
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                <br />
              </td>
            </tr>
            <tr>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                10800
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                3 heures
              </td>

              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                691200
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(136, 136, 136);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                8 jours
              </td>
              <td
                style="
                  vertical-align: top;
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                <br />
              </td>
              <td
                style="
                  vertical-align: top;
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                <br />
              </td>
            </tr>
            <tr>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                21600
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                6 heures
              </td>

              <td
                style="
                  vertical-align: top;
                  background-color: rgb(102, 102, 102);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                2678400
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(102, 102, 102);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                1 mois
              </td>
              <td
                style="
                  vertical-align: top;
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                <br />
              </td>
              <td
                style="
                  vertical-align: top;
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                <br />
              </td>
            </tr>
            <tr>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                28800
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                8 heures
              </td>

              <td
                style="
                  vertical-align: top;
                  background-color: rgb(102, 102, 102);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                8035200
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(102, 102, 102);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                3 mois
              </td>
              <td
                style="
                  vertical-align: top;
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                <br />
              </td>
              <td
                style="
                  vertical-align: top;
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                <br />
              </td>
            </tr>
            <tr>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                36000
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                10 heures
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(102, 102, 102);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                16070400
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(102, 102, 102);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                6 mois<br />
              </td>
            </tr>
            <tr>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                43200
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                12 heures
              </td>
            </tr>
            <tr>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                86400
              </td>
              <td
                style="
                  vertical-align: top;
                  background-color: rgb(160, 160, 160);
                  font-family: Helvetica, Arial, sans-serif;
                "
              >
                24 heures
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { computed } from "@vue/composition-api";

export default {
  props: {
    cardModelForm: Object,
    rules: Object,
    cardOriginsChoice: Array,
    cardTypesChoice: Array,
  },
  setup(props, { emit }) {
    const parentCardModelForm = computed({
      get: () => props.cardModelForm,
      set: (value) => {
        emit("update:cardModelForm", value);
      },
    });

    return {
      parentCardModelForm,
    };
  },
};
</script>
